import React from 'react'
import Shimmer from '../../../component/Shimmer'
import { Link, useNavigate } from 'react-router-dom'
import { IoPersonCircleSharp, IoLogOutOutline } from 'react-icons/io5'
import { navAnchorLinks } from '../../../assets/Link/navbarLinks'
import { useDispatch } from 'react-redux'
import { logoutUser } from '../../../redux/auth/action/LoginAction'

function ProfileLinks({loading, firstName, isMobile = false}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate('/');
  };

  return (
    <div className={`flex items-center ${isMobile ? 'flex-col space-y-4' : 'space-x-4'}`}>
        <a
            href={navAnchorLinks[1].link}
            target={navAnchorLinks[1].target}
            rel={navAnchorLinks[1].rel}
            className="font-poppins text-base text-black font-semibold ml-2"
        >
            {navAnchorLinks[1].title}
        </a>

        {loading && <Shimmer width="45px" height="20px" borderRadius="rounded" />}
        {!loading && firstName && 
            <Link to="/dashboard" className="flex items-center ml-4">
                <IoPersonCircleSharp
                    size={25}
                    className="cursor-pointer text-black"
                />
                <p className="ml-1 font-poppins text-base text-nowrap text-black font-medium">
                    {firstName}
                </p>
            </Link>}
        {!loading && !firstName && 
            <Link to="/login" className="flex items-center ml-4">
                <IoPersonCircleSharp
                    size={25}
                    className="cursor-pointer text-black"
                />
                <p className="ml-1 font-poppins text-base text-nowrap text-black font-medium">
                    Login
                </p>
            </Link>}
        
        {/* Add logout button for mobile view when user is logged in */}
        {isMobile && !loading && firstName && (
            <button
                onClick={handleLogout}
                className="flex items-center justify-center w-full px-4 py-2 text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition-colors duration-200"
            >
                <IoLogOutOutline size={20} className="mr-2" />
                <span className="font-poppins text-base font-medium">Logout</span>
            </button>
        )}
    </div>
  )
}

export default ProfileLinks
